export default "__VITE_ASSET__7HnHEdvt__"